import * as React from 'react';
import { ModalWindow, Button } from '@cian/ui-kit';
import { AreaFilterContainer } from '../area';
import { FloorCountsFilterContainer } from '../floor_count';
import { HeatingSourceTypeFilterContainer } from '../heating_source_type';
import { HouseMaterialsFilterContainer } from '../house_material';
import { OtherCommunicationFilterContainer } from '../other_communications';
import { ReadyStatusFilterContainer } from '../ready_status';
import { SaleStatusFilterContainer } from '../sale_status';
import { WcLocationTypeFilterContainer } from '../wc_location_type';
import { IExtraFiltersModalDispatchProps, IExtraFiltersModalStateProps } from './container';
import { ModalRow } from './ModalRow';
import { DistanceContainer } from '../../../../containers/filters/DistanceContainer';

import * as styles from './index.css';
import { BlackFridayFlagContainer } from '../../../../containers/filters/BlackFridayFlagContainer';

export interface IExtraFiltersModalOwnProps {
  onClose(): void;
}

type TProps = IExtraFiltersModalStateProps & IExtraFiltersModalDispatchProps & IExtraFiltersModalOwnProps;

export class ExtraFiltersModal extends React.Component<TProps, {}> {
  public render() {
    return (
      <ModalWindow
        open
        fixed
        width={1030}
        onClose={this.props.onClose}
        title="Ещё фильтры"
        footer={
          <div className={styles['footer']}>
            <Button
              aria-label="Сбросить фильтры"
              size="XS"
              theme="fill_white_primary"
              onClick={this.props.resetFilters}
            >
              Сбросить фильтры
            </Button>
            <Button aria-label="Показать посёлки" size="XS" onClick={this.applyFilters}>
              Показать посёлки
            </Button>
          </div>
        }
        content={
          <div className={styles['content']}>
            {this.props.showBlackFridayFilter && (
              <ModalRow label="Скидки" name="Promotions">
                <BlackFridayFlagContainer />
              </ModalRow>
            )}
            <ModalRow label="Расстояние" name="Distance">
              <DistanceContainer />
            </ModalRow>
            <ModalRow label="Статус продаж" name="SaleStatus">
              <SaleStatusFilterContainer />
            </ModalRow>
            <ModalRow label="Готовность посёлка" name="ReadyStatus">
              <ReadyStatusFilterContainer />
            </ModalRow>
            <ModalRow label="Площадь дома" name="HouseArea">
              <AreaFilterContainer />
            </ModalRow>
            <ModalRow label="Материал дома" name="HouseMaterial">
              <HouseMaterialsFilterContainer />
            </ModalRow>
            <ModalRow label="Этажей в доме" name="FloorCount">
              <FloorCountsFilterContainer />
            </ModalRow>
            <ModalRow label="Тип отопления" name="HeatingType">
              <HeatingSourceTypeFilterContainer />
            </ModalRow>
            <ModalRow label="Санузел" name="WcLocationType">
              <WcLocationTypeFilterContainer />
            </ModalRow>
            <ModalRow label="Наличие коммуникаций" name="Communications" align="center">
              <OtherCommunicationFilterContainer />
            </ModalRow>
          </div>
        }
      />
    );
  }

  private applyFilters = () => {
    this.props.onClose();
    this.props.applyFilters();
  };
}
